export const GET_SURVEY_FORMS_DATA = 'GET_SURVEY_FORMS_DATA';
export const GET_SURVEY_FORMS_DATA_SUCCESS = 'GET_SURVEY_FORMS_DATA_SUCCESS';
export const GET_SURVEY_FORMS_DATA_FAIL = 'GET_SURVEY_FORMS_DATA_FAIL';

export const GET_SURVEY_SINGLE_FORM_DATA = 'GET_SURVEY_SINGLE_FORM_DATA';
export const GET_SURVEY_SINGLE_FORM_SUCCESS = 'GET_SURVEY_SINGLE_FORM_SUCCESS';
export const GET_SURVEY_SINGLE_FORM_FAIL = 'GET_SURVEY_SINGLE_FORM_FAIL';
